import {
  amsStoreSnapshot,
  setAmsRedirectUrl,
} from '../repositories/ams/ams.repository';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const HasAmsFeatureGuard: CanActivateFn = (...args) => {
  const router = inject(Router);
  const loadingUrlTree = router.parseUrl('/ams/loading');

  const { url } = args[1];

  const options = amsStoreSnapshot().primaryNavOptions?.values ?? [];
  if (options.length === 0) {
    setAmsRedirectUrl(url);
    return loadingUrlTree;
  }

  const amsUrls = options.map((option) => option.url);
  return amsUrls.some((amsUrl) => url.startsWith(amsUrl))
    ? true
    : loadingUrlTree;
};
